import React, {useState }from 'react';
import { useSelector, useDispatch } from "react-redux";
import { resetPagination } from 'reducers/paginationArticlesSlice';
import { resetFilters } from 'reducers/filtersArticlesSlice';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { useParams } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { ToastContainer } from 'react-toastify'; 
import { TodayIs } from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import ColorSettings  from "pages/settings/ColorSettings";
import TypesOfPrices from"pages/settings/TypesOfPricesSettings";
import TypesOfUnits from"pages/settings/TypesOfUnitsSettings"; 
import TypesOfSizes from"pages/settings/TypesOfSizesSettings";
import TypesOfTaxes from"pages/settings/TypesOfTaxesSettings";
import DepartmentSettings from "pages/commonsarticle/departmentSettings/DepartmentSettings";
import ArticleEditOrCreate from "pages/articles/articleEditOrCreate/ArticleEdit";
const HomeArticleEditData = () => {

    const {t,i18n} = useTranslation(['listDataArticles']);
    const {id} = useParams();
    const dispatch = useDispatch();
    const enabled = useSelector((state) => state.loginUser.enabled);
    const roles = useSelector((state) => state.loginUser.roles);  
    const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalColorSettings, setShowModalColorSettings] = useState(false);
    const [showModalTypesOfPrices, setShowModalTypesOfPrices] = useState(false);
    const [showModalTypesOfUnit,setShowModalTypesOfUnit] = useState(false);
    const [showModalTypesOfSizes,setShowModalTypesOfSizes] = useState(false);
    const [showModalTypesOfTaxes,setShowModalTypesOfTaxes] = useState(false);
    const [showDepartmentSettings, setShowModalDepartmentSettings] = useState(false);
    const [showPrincipalMenu, setShowPrincipalMenu] = useState(true); 
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalDriverSettings, setShowModalDriverSettings] = useState(true);
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(true); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(true); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
       
    const scriptUrl = '/js/sb-admin-2.min.js'; 
    const navigate = useNavigate(); 
  
    const handleCloseStoreEditData = () => {
         setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(true);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(showModalGeneralSettings);
        setShowPrincipalMenu(showPrincipalMenu);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalDriverSettings(showModalDriverSettings);
        setShowModalStoreSettings(showModalStoreSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        dispatch(resetPagination());
        dispatch(resetFilters());
        navigate("/article");
    };
    
    function changeSelectedLanguage(){
        i18n.language==="es"?i18n.changeLanguage("en"):i18n.changeLanguage("es");        
    };
    
    function openModaColorsSettings(){
        setIndexShowSettings(1);
        setShowModalColorSettings(true);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfPriceSettings(){
        setIndexShowSettings(25);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(true);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
 
   function openModaSalesUnitsSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(true);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfSizeSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(true);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfTaxSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(true);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
 
    function openModaDepartmentSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfTaxes(false);
        setShowModalDepartmentSettings(true);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
 
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/home"></Navigate>:
        <div id="page-top">

            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))?
                        <li className="nav-item">
                            <Link className="nav-link collapsed"to={`/articledetail/${id}`} data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6> 
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Colors"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaColorsSettings}>{t('SubMenu_Settings_Type_Colors')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }}  to={`/articledetail/${id}`}>{t('SubMenu_Settings_Type_Colors')} </Link>}              
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfPrice"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaTypesOfPriceSettings}>{t('SubMenu_Settings_Type_Prices')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={`/articledetail/${id}`}>{t('SubMenu_Settings_Type_Prices')} </Link>}              
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfUnit"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaSalesUnitsSettings}>{t('SubMenu_Settings_SalesUnits')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={`/articledetail/${id}`}>{t('SubMenu_Settings_SalesUnits')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfSize"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaTypesOfSizeSettings}>{t('SubMenu_Settings_TypesOfSizes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={`/articledetail/${id}`}>{t('SubMenu_Settings_TypesOfSizes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfTax"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaTypesOfTaxSettings}>{t('SubMenu_Settings_TypesOfTaxes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={`/articledetail/${id}`}>{t('SubMenu_Settings_TypesOfTaxes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Department"))?
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={openModaDepartmentSettings}>{t('SubMenu_Settings_Departments')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={`/articledetail/${id}`}>{t('SubMenu_Settings_Departments')} </Link>}
                                    <Link className="collapse-item" to={`/articledetail/${id}`} onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                </div>
                            </div>
                        </li>:
                        <li className="nav-item" style={{ textDecorationLine: 'line-through' }}>
                            <Link className="nav-link" to="/home">
                            <SettingsIcon/>
                                <span > {t('Menu_Settings')}</span>
                            </Link>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to={`/article`} onClick={handleCloseStoreEditData}>
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>         
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}
                
               <ArticleEditOrCreate                  
                    id={id}
                    showModalArticlesSettings={showModalArticlesSettings} 
                />
                <ColorSettings  
                    showModalColorSettings={showModalColorSettings}
                    setShowModalColorSettings={setShowModalColorSettings}
                    setIndexShowSettings={setIndexShowSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfPrices                  
                    showModalTypesOfPrices={showModalTypesOfPrices}
                    setShowModalTypesOfPrices={setShowModalTypesOfPrices}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings} 
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfUnits   
                    showModalTypesOfUnit={showModalTypesOfUnit}
                    setShowModalTypesOfUnit={setShowModalTypesOfUnit}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfSizes  
                    showModalTypesOfSizes={showModalTypesOfSizes} 
                    setShowModalTypesOfSizes={setShowModalTypesOfSizes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true} 
                     setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfTaxes   
                    showModalTypesOfTaxes={showModalTypesOfTaxes} 
                    setShowModalTypesOfTaxes={setShowModalTypesOfTaxes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true} 
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <DepartmentSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    showDepartmentSettings={showDepartmentSettings} 
                    setShowModalDepartmentSettings={setShowModalDepartmentSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                    <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         


      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeArticleEditData;
